import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
    AmexIcon,
    ApplePayIcon,
    DiscoverIcon,
    GooglePayIcon,
    MasterCardIcon,
    VenmoIcon,
    VisaIcon
} from './PaymentIcons';
import { NativePaymentsTypes } from '../../../utils/enums';
import { height } from '../../../utils/size';

const calculatePaymentButtonHeight = (n, isDesktop) => {
    const wrapper = document.getElementById('NativePaymentButtonWrapper');
    if (!wrapper) {
        return 95;
    }
    const availableSpace = height() - wrapper.offsetTop - (isDesktop ? 55 : 95);
    const buttonSize = !isDesktop
        ? (0.9 * availableSpace) / n - 20
        : (availableSpace * 1.45) / 4;
    return Math.min(120, buttonSize);
};

export const PaymentTypeButton = styled.button`
    align-items: center;
    background: #fff;
    border-radius: 4px;
    border: solid 1px #f1f1ee;
    color: #333;
    cursor: ${props => (props.valid ? 'pointer' : 'not-allowed')};
    display: ${props => (props.hidden ? 'none' : 'flex')};
    ${props => (props.isDesktop ? 'flex: 0 50%;' : '')}
    justify-content: center;
    margin: 5px 0;
    height: ${props =>
        calculatePaymentButtonHeight(props.numberOfPaymentTypes, props.isDesktop)}px;
    opacity: ${props => (props.valid ? 1 : 0.5)};
    transition: opacity 250ms ease;
    width: 100%;
    padding: 0;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 1);

    &:active,
    &focus {
        outline: none;
    }
`;

const CreditCardGroup = styled.div`
    svg {
        margin: ${props => (props.isDesktop ? `0 2.5px` : `0 5px`)};
    }
`;

export const NativePaymentsIcon = props => {
    switch (props.paymentType) {
        case NativePaymentsTypes.applePay:
            return <ApplePayIcon />;
        case NativePaymentsTypes.googlePay:
            return <GooglePayIcon />;
        case NativePaymentsTypes.venmo:
            return <VenmoIcon />;
        case NativePaymentsTypes.credtCard:
            return (
                <CreditCardGroup isDesktop={props.isDesktop}>
                    <AmexIcon height={props.isDesktop ? 18 : 25} />
                    <DiscoverIcon height={props.isDesktop ? 18 : 25} />
                    <MasterCardIcon height={props.isDesktop ? 18 : 25} />
                    <VisaIcon height={props.isDesktop ? 18 : 25} />
                </CreditCardGroup>
            );
        default:
            return null;
    }
};

NativePaymentsIcon.propTypes = {
    isDesktop: PropTypes.bool.isRequired,
    paymentType: PropTypes.number.isRequired
};
